export default class dropZone {
    constructor() {
        return {
            restrict: 'E',
            replace: true,
            controller: DropZoneCtrl,
            controllerAs: 'dz',
            template: '<div class="drop-zone"><i class="glyphicon glyphicon-download"></i></div>'
        }
    }
};

class DropZoneCtrl {
    constructor($scope, $element, $compile, BlockService) {
        this.dropZone = $element;
        this._scope = $scope;
        this._compile = $compile;

        this.dropZone.on('dragenter', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.dropZone.addClass('inRange');
        }).on('dragleave', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.dropZone.removeClass('inRange');
        }).on('dragover', (event) => {
            event.preventDefault();
            event.stopPropagation();
        }).on('drop', (event) => {
            event.preventDefault();
            event.stopPropagation();

            let blockName = event.originalEvent.dataTransfer.getData('rule/block');
            let blockHtml = BlockService.getByName(blockName).block.outerHTML;
            let block = this._compile(blockHtml)(this._scope);

            this.dropZone.replaceWith(block);

            $(block).css('display', 'none');
            $(block).slideDown("slow");
            
            this._scope.$emit('element:added', block);
        });
    }
}
